module.exports = "https://static.wmbcdn.com/uniweb/images/8f70a3108da18d5d5a4a87c6fb9e33a0.svg";